module.exports = __webpack_public_path__ + "static/img/icon-post.71e5bc6b.png";